import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { PendingPlanChange } from "../schema/usage";

interface PendingPlanChangeNoticeProps {
	pendingPlanChange?: PendingPlanChange | null;
}

/**
 * Info banner for a scheduled plan change (deferred downgrade/upgrade): the customer stays on
 * the current plan until the effective date, so without this notice the unchanged plan reads
 * as "my downgrade didn't work".
 */
export const PendingPlanChangeNotice: FunctionComponent<PendingPlanChangeNoticeProps> = ({
	pendingPlanChange,
}) => {
	const { t } = useTranslation();

	if (!pendingPlanChange) {
		return null;
	}

	const effectiveAt = new Date(pendingPlanChange.effectiveAt).toLocaleDateString("de-DE", {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	});

	return (
		<div className="text-sm text-text-meta bg-status-info-light border border-status-info rounded-md p-3 mb-3">
			{t("usage.subscription.overview.pendingPlanChange", {
				name: pendingPlanChange.productName,
				credits: pendingPlanChange.credits.toLocaleString("de-DE"),
				interval: t(
					`usage.subscription.overview.pendingPlanIntervals.${pendingPlanChange.interval}`
				),
				date: effectiveAt,
			})}
		</div>
	);
};
